var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"vrm-modal vrm-modal--remote-console-choice"},[_c('div',{staticClass:"vrm-modal__header-gradient"}),_c('div',{staticClass:"vrm-modal__content"},[_c('vrm-remote-console-choice-container',{attrs:{"id-site":_vm.idSite,"on-selected":_vm.onSelected}})],1),_c('modal-close-handle')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }